import { createRoot } from 'react-dom/client';
import { initSentry, loadConfig } from '@petseo/shared';
import { initializeSuperTokens } from './providers/SuperTokens.init';
import App from './App.tsx';
import '@tabler/core/dist/css/tabler.min.css';
import '@tabler/core/dist/js/tabler.min.js';
import '@petseo/shared/styles.css';
import './styles/index.css';

async function bootstrap() {
  const config = await loadConfig();
  initSentry('https://e118ca1b6c6696a53ebf88c8bff8bef7@o4510510958444544.ingest.de.sentry.io/4511059276595280', config.environment.toLowerCase());
  initializeSuperTokens(config);
  createRoot(document.getElementById('root')!).render(<App />);
}

bootstrap();
